// extracted by mini-css-extract-plugin
module.exports = {"img":"Background_img__g5Yay"};